import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/smart-leads`;

// One-click send: checks safety rules, shows From/To/Subject, sends from the location's Outlook.
export const EmailSendConfirm = ({ leadId, subject, body, disabled, onSent }) => {
  const [chk, setChk] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try { setChk((await axios.get(`${API}/email/send-check`, { params: { lead_id: leadId } })).data); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not check"); } finally { setBusy(false); }
  };
  const send = async () => {
    setBusy(true);
    try {
      const r = (await axios.post(`${API}/email/send`, { lead_id: leadId, subject, body })).data;
      toast.success(`Sent to ${r.to} from ${r.from} (${r.sent_today}/${r.daily_limit} today)`); setChk(null); onSent();
    } catch (e) { toast.error(e?.response?.data?.detail || "Send failed"); } finally { setBusy(false); }
  };
  return (
    <>
      <Button size="sm" className="bg-blue-600 hover:bg-blue-700" disabled={disabled || busy} onClick={open} data-testid="focus-email-send-btn">
        {busy && !chk ? <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" /> : <Mail className="w-3.5 h-3.5 mr-1" />}Send email</Button>
      <AlertDialog open={!!chk} onOpenChange={(o) => !o && setChk(null)}>
        <AlertDialogContent data-testid="email-send-confirm">
          <AlertDialogHeader>
            <AlertDialogTitle>{chk?.can_send ? "Send this email now?" : "Can't send this email"}</AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="space-y-1 text-sm text-slate-700">
                <div>From: <b>{chk?.from || "—"}</b></div>
                <div>To: <b>{chk?.to_name} &lt;{chk?.to}&gt;</b></div>
                <div>Subject: <b>{subject}</b></div>
                {chk?.can_send ? <div className="text-xs text-slate-500 pt-1">{chk.sent_today}/{chk.daily_limit} sent today · a copy goes to Sent Items and the lead's history.</div>
                  : <div className="text-rose-600 font-semibold pt-1" data-testid="email-send-blocked">{chk?.reason}</div>}
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="email-send-cancel">Cancel</AlertDialogCancel>
            {chk?.can_send && <AlertDialogAction onClick={(e) => { e.preventDefault(); send(); }} disabled={busy} className="bg-blue-600 hover:bg-blue-700" data-testid="email-send-confirm-btn">
              {busy && <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" />}Send now</AlertDialogAction>}
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
